import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class TesztlapokDto extends IdentifiableDto {
	constructor() {
		super();
		this.vizsgazoAzonosito = null;
		this.oldal = null;
		this.csomagNev = null;
		this.feltoltoTesztlapNev = null;
		this.feltoltesIdeje = null;
		this.vizsgaLeiras = null;
		this.modositva = null;
	}

	setup(props) {
		super.setup(props);
		this.vizsgazoAzonosito = props.vizsgazoAzonosito;
		this.oldal = props.oldal;
		this.csomagNev = props.csomagNev;
		this.feltoltoTesztlapNev = props.feltoltoTesztlapNev;
		this.feltoltesIdeje = props.feltoltesIdeje;
		this.vizsgaLeiras = props.vizsgaLeiras;
		this.modositva = props.modositva;
		return this;
	}
}

export default TesztlapokDto;
